// extracted by mini-css-extract-plugin
var _1 = "ZebraDetailsCardStyle-module__divider___k8biR";
var _2 = "ZebraDetailsCardStyle-module__divider-primary___XrfPQ";
var _3 = "ZebraDetailsCardStyle-module__divider-secondary___ixwTa";
var _4 = "ZebraDetailsCardStyle-module__divider-primary___XrfPQ";
var _5 = "ZebraDetailsCardStyle-module__divider-secondary___ixwTa";
var _6 = "ZebraDetailsCardStyle-module__label___ASzxY";
var _7 = "ZebraDetailsCardStyle-module__label-secondary___Ei0aR";
var _8 = "ZebraDetailsCardStyle-module__label-secondary___Ei0aR";
var _9 = "ZebraDetailsCardStyle-module__zebra-details-card___oVhl4";
var _a = "ZebraDetailsCardStyle-module__zebra-details-card___oVhl4";
export { _1 as "divider", _2 as "divider-primary", _3 as "divider-secondary", _4 as "dividerPrimary", _5 as "dividerSecondary", _6 as "label", _7 as "label-secondary", _8 as "labelSecondary", _9 as "zebra-details-card", _a as "zebraDetailsCard" }
